import ApiLogin from '@/services/ApiLogin'
import LocalStorageService from './LocalStorageService'

class LoginService {
  login (username, password) {
    return ApiLogin().post('login', { username, password })
  }

  validateAuthorization () {
    return ApiLogin().post('validate-authorization')
  }

  getUserDetails () {
    return ApiLogin().get('user-details')
  }

  getAllClients () { // do usuário
    return ApiLogin().get(LocalStorageService.getUserClientPrefix() + '/client')
  }
}

export default new LoginService()
